import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2, Film, Lock } from "lucide-react";
import api, { fileUrl } from "@/lib/api";
import { Logo } from "@/components/Common";

export default function StoryFilm() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.get(`/stories/film/${slug}`).then((r) => setData(r.data)).catch(() => setErr(true)); }, [slug]);

  if (err) return <div className="min-h-screen grid place-items-center bg-[hsl(var(--letterbox))] text-[hsl(var(--letterbox-foreground))]">This story isn't available.</div>;
  if (!data) return <div className="min-h-screen grid place-items-center bg-[hsl(var(--letterbox))]"><Loader2 className="animate-spin text-white/70" /></div>;

  return (
    <div className="min-h-screen bg-[hsl(var(--letterbox))] text-[hsl(var(--letterbox-foreground))]" data-testid="story-film-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-10">
        <div className="flex justify-center opacity-90"><Logo light /></div>
        <div className="mt-8 text-center">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-white/50">A Keepsake Story</p>
          <h1 className="mt-2 font-display text-4xl sm:text-5xl font-semibold">{data.title}</h1>
        </div>
        {data.state === "ready" ? (
          <div className="mt-8">
            <video src={fileUrl(data.film.file_id)} controls autoPlay={false} className="w-full rounded-2xl bg-black aspect-video shadow-2xl" data-testid="story-film-video" />
            {data.versions?.length > 1 && (
              <div className="mt-4 flex flex-wrap justify-center gap-2">
                {data.versions.map((v) => <a key={v.version_id} href={fileUrl(v.file_id)} target="_blank" rel="noreferrer" className="px-3 py-1.5 rounded-lg bg-white/10 hover:bg-white/20 text-sm">{v.label}</a>)}
              </div>
            )}
          </div>
        ) : (
          <div className="mt-10 text-center text-white/70">
            {data.state === "private" ? <><Lock className="mx-auto" /><p className="mt-2">This story is private.</p></>
              : <><Film className="mx-auto" /><p className="mt-2">The film is still being produced. Please check back soon.</p></>}
          </div>
        )}
      </div>
    </div>
  );
}
